import { MachineOptions } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';
import {
  addToCartFailure,
  addToCartSuccess,
  getCartFailure,
  getCartSuccess,
  getProductWithMeasurementsFailure,
  getProductWithMeasurementsSuccess,
  updateCustom,
  updateUrl,
} from '../actions';
import { idleTransitionGuards } from '../guards/idleTransitionGuards';

export const productBuilderMachineOptions: MachineOptions<
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent
> = {
  actions: {
    addToCartFailure,
    addToCartSuccess,
    getCartSuccess,
    getCartFailure,
    getProductWithMeasurementsFailure,
    getProductWithMeasurementsSuccess,
    updateCustom,
    updateUrl,
  },
  activities: {},
  delays: {},
  guards: {
    hasMeasurements: ({ custom: { measurements } }) => {
      return Boolean(measurements);
    },
    hasProductWithMeasurements: ({ productWithMeasurements }) => {
      return productWithMeasurements !== null;
    },
    ...idleTransitionGuards,
  },
  services: {},
};
